import React from 'react';
import styled from 'styled-components';

const TransactionsTopMenuWrapper = styled.div`
  height: 50px;
  background-color: #f2f4f9;
  border-radius: 10px;
  padding: 5px;
  display: flex;
  align-items: center;
  grid-gap: 0 8px;
  width: fit-content;
  @media only screen and (max-width: 965px) {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

const TransactionMenuItem = styled.div<{ isActive: boolean }>`
  background-color: ${(props) => (props.isActive ? '#ffffff' : '')};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  height: 38px;
  cursor: pointer;
  @media only screen and (max-width: 965px) {
    padding: 0 8px;
  }
  p {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    color: ${(props) => (props.isActive ? '#000000' : '#9DA3B7')};

    @media only screen and (max-width: 476px) {
      font-size: 12px;
    }
  }
`;

interface MenuItemProps {
  title: string;
  isActive: boolean;
  index: number;
}

interface TransactionMenuItemProps {
  menuItems: MenuItemProps[];
  onClick: (index: number) => void;
  dataTour?: any;
}

const TransactionsTopMenu = ({
  menuItems,
  onClick,
  dataTour,
}: TransactionMenuItemProps): JSX.Element => {
  return (
    <TransactionsTopMenuWrapper data-tour={dataTour}>
      {menuItems.map((menuItem, key) => (
        <TransactionMenuItem
          key={key}
          onClick={() => onClick(menuItems.indexOf(menuItem))}
          isActive={menuItem.isActive}
        >
          <p>{menuItem.title}</p>
        </TransactionMenuItem>
      ))}
    </TransactionsTopMenuWrapper>
  );
};

export default TransactionsTopMenu;
